import React, { useEffect, useState } from "react";
import "@/styles/components/heroSection2.scss";
import Container from "@/components/container/Container";
import ButtonComponent from "@/components/button/Button";
import { useNavigate } from "react-router-dom";

const HeroSection2 = () => {
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const data = {
    heading: (
      <span>
        {windowWidth < 600 ? (
          <>
            <span>A</span> <span className="color-brand bold">direct helpline</span>{" "}
            <span>to buddies</span>
          </>
        ) : (
          "Got questions?"
        )}
      </span>
    ),
    subHeading: `${windowWidth < 600 ? `in universities abroad` : "We have the answer's."}`,
    firstbutton: "Connect now",
    heroImage: `/assets/images/${windowWidth < 600 ? "inforens-hero" : "banner-img"}.png`,
  };

  const handleBookSession = () => {
    navigate("/membership");
  };

  // Modifying handleResize to update windowWidth state
  const handleResizeWithWidthUpdate = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResizeWithWidthUpdate);
    return () => {
      window.removeEventListener("resize", handleResizeWithWidthUpdate);
    };
  });

  return (
    <div className="heroSection2-wrapper">
      <Container className="heroSection2-container">
        <div className="content-wrapper">
          <div className="heading">Welcome to Inforensverse.</div>
          <div className="subheading-mobile-view">
            Join us for exclusive events, internships opportunities, jobs, cashback on university
            fees, discounts, and guidance from our mentors.
          </div>
          <div className="subheading-web-view">
            Thrive with our Inforens community by your side.
          </div>
          <p className="web-view-content">
            Exclusive events and trips, cashback on university fees, cool discounts for everyday
            life and our inforens mentors for friendly advice and tips.
          </p>
          <div className="button-container">
            <ButtonComponent
              className="button-container-first"
              varient="primary"
              size={"large"}
              label="Explore now"
              onClick={handleBookSession}
            />
          </div>
        </div>
        <div className="hero-video">
          <img src={"/assets/inforens-video.gif"} alt="" />
        </div>
      </Container>
    </div>
  );
};

export default HeroSection2;
